module.exports = __webpack_public_path__ + "static/media/money_pig.4d8cd291.svg";